/**
 * @generated SignedSource<<0d868956cb5ee8b6832cb78b969138bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItemBadge_notifications">;
  readonly " $fragmentType": "NavItem_notifications";
};
export type NavItem_notifications$key = {
  readonly " $data"?: NavItem_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemBadge_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "851c324c2aa0216c327fab2bb30daec7";

export default node;
